import React, { useState, useEffect } from "react";
import AppBox from "@/components/AppBox";
import AppDropdown from "@/components/AppDropdown";
import AppText from "@/components/AppText";

interface FollowupDelayItem {
  value: number;
  label: string;
}

interface Followup {
  delay: number;
}

interface FollowupDelayDropdownProps {
  followup: Followup;
  followupDelayList: FollowupDelayItem[];
  onChange: (newValue: number) => void;
  label?: string;
  disabled?: boolean;
}

const FollowupDelayDropdown: React.FC<FollowupDelayDropdownProps> = ({
  followup,
  followupDelayList,
  onChange,
  label,
  disabled,
}) => {
  const [selectedDelay, setSelectedDelay] = useState<number>(followup.delay);

  // Update local state when `followup.delay` changes
  useEffect(() => {
    setSelectedDelay(followup.delay);
  }, [followup.delay]);

  const handleChange = (newValue: string | number) => {
    const numericValue = typeof newValue === "string" ? parseInt(newValue, 10) : newValue;
    if (!isNaN(numericValue)) {
      setSelectedDelay(numericValue);
      onChange(numericValue);
    } else {
      console.error("Invalid value:", newValue);
    }
  };

  return (
    <AppBox column width={160} gap={1}>
      {/* Label */}
      {label && (
        <AppText color={disabled ? "disabled" : "dark"} variant="label">
          {label}
        </AppText>
      )}

      {/* Dropdown */}
      <AppDropdown
        label={
          followupDelayList.find((item) => item.value === selectedDelay)?.label || "Select Delay"
        }
        items={followupDelayList}
        value={selectedDelay}
        onChange={handleChange}
        disabled={disabled}
      />
    </AppBox>
  );
};

export default FollowupDelayDropdown;